/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
/**
 * GetAvailableLanguages Input Action
 */
export class GetAvailableCountriesInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `availableCountries`;
    public getCacheObjectType = () => 'availableCountries';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}
export interface IGetAvailableCountriesData {
    key: string;
    value: string;
    InternationalCallingCode: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetAvailableCountriesInput();
};

async function action(input: GetAvailableCountriesInput, ctx: Msdyn365.IActionContext): Promise<IGetAvailableCountriesData[]> {
    let result: any[] = [];
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecGetAllChannelCountries(languageId='${ctx.requestContext.locale}')`,
        'get',
        {},
        {
            headers: { OUN: ctx.requestContext.apiSettings.oun }
        }
    )
        .then(res => {
            result = (res?.data as any).value;
        })
        .catch(ex => {
            console.log('Error', ex);
        });

    const availableCountries = result.map((val: any) => {
        return { key: val.CountryCode, value: val.CountryShortname, InternationalCallingCode: val.InternationalCallingCode };
    });
    return availableCountries;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAvailableCountriesData[]>>action,
    id: 'GetAvailableCountries',
    input: createInput
});
